import { takeEvery } from 'redux-saga/effects';
import { verifyEmailSaga } from '../sagas/emailVerify';
import { INIT_EMAIL_VERIFIED } from '../types';

export function* watchEmailVerify() {
  yield takeEvery(INIT_EMAIL_VERIFIED, verifyEmailSaga);
}
